export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref4856.83123dd1.jpg";